import { AppConfig } from '../context/tribal';
import { ConfigManager } from '@tribal-worldwide-london/fa-config';

export default (configManager: ConfigManager, appConfig: AppConfig) => {
  return {
    eventInfo: {
      eventAction: null,
      activatedFeatures: null,
      abTestFeatures: null,
      pageId: window.location.href,
      pageName: 'Online PB',
      contentId: null,
      contentLabels: null,
      pageCategory: null,
      sectionName: null,
      templateType: null,
      brand: configManager.get('brand'),
    },
    environment: {
      applicationId: null,
      applicationIdVersion: configManager.get('appVersion'),
      featureAppId: null,
      featureAppIdAppVersion: configManager.get('appVersion'),
      featureAppVariant: null,
      featureAppState: null,
      language: null,
      country: null,
      region: null,
      commerce: false,
      status: process.env.NODE_ENV ? process.env.NODE_ENV : null,
    },
    user: {
      locationLatitude: null,
      locationLongitude: null,
      locationZIP: null,
      locationCity: null,
      loginStatus: null,
      browserResolutionHeight: window?.screen?.height?.toString() || null,
      browserResolutionWidth: window?.screen?.width?.toString() || null,
      browserResolutionBreakpoint: null,
      browserResolutionOrientation:
        window?.screen?.orientation?.type?.startsWith('portrait_') ? 'v' : 'h',
      customerType: configManager.get('customerType'),
      customerContractsCount: null,
      dealerStatus: null,
      dealerInformationBnr: null,
      dealerInformationName: null,
      dealerInformationType: null,
      dealerInformationCountry: null,
    },
    page: null,
    content: {
      BrochureId: appConfig.pdbId,
    },
    personalization: null,
    bbo: null,
    configuration: null,
    configurations: null,
    partner: null,
    form: null,
    process: null,
    link: null,
    error: null,
    video: null,
    filter: null,
    questionaire: null,
    ownership: null,
    commerce: null,
    tab: null,
  };
};
